export enum VendorInternal {
    FINANCE = 'Finance'
}
